<template>
  <div class="music-quiz">
    <VideoBanner :v-if='$route.name === "Music Quiz"' posterSrc='musikquiz.jpg' mp4Src='musikquiz.mp4' webmSrc='musikquiz.webm' :overlayTitle='$COMPANY.NAME' :overlayDescription='$COMPANY.DESCRIPTION' />
    <div class="main-content small-content">
      <b-container>
        <h2>Musikquiz</h2>
        <div class="music-quiz-content page-content">
          <b-row>
            <b-col>
              <h3>En rolig och interaktiv upplevelse för alla musikälskare</h3>
              <p>Älskar du musik och tävling? Då är vårt musikquiz perfekt för ditt nästa event! Utmana dig själv och dina vänner eller kollegor i en rolig och lärorik frågesport där musik och trivia står i fokus.</p>
              <h3>Digitalt eller klassiskt - du väljer!</h3>
              <p>Vi erbjuder både digitala musikquizar för en smidig och modern upplevelse och den klassiska varianten med papper och penna, för dig som föredrar den traditionella stilen. Oavsett format får du ett quiz som är anpassat för just din grupp och event.</p>
              <h3>Enkla regler, massor av skratt</h3>
              <p>Våra musikquiz är lämpliga för alla typer av tillställningar,  från företagsfester och jubileum till privata sammankomster. Vi ser till att alla får en rolig upplevelse, oavsett om de är musikexperter eller bara gillar att ha kul.</p>
              <p class="last-pop">Kontakta oss för att boka ditt musikquiz och skapa en oförglömlig upplevelse!</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import VideoBanner from './VideoBanner'

export default {
  components: {
    VideoBanner
  }
}
</script>

<style>

</style>
